import { fromEmpty } from 'maybeasy';
import { observer } from 'mobx-react';
import { DragDropContext, Draggable, Droppable, DroppableProvided } from '@hello-pangea/dnd';
import { emptyFragment } from '../../../../../../../../EmptyFragment';
import PreviewStore from '../../Store';
import SectionContent from './SectionContent';

interface Props {
  store: PreviewStore;
}

function Sections({ store }: Props) {
  return fromEmpty(store.learningCollectionStore.sections)
    .map((sections) => (
      <DragDropContext onDragEnd={store.learningCollectionStore.handleOnDragEndSections}>
        <Droppable droppableId="characters">
          {(provided: DroppableProvided) => (
            <div {...provided.droppableProps} ref={provided.innerRef}>
              {sections.map((section, index) => (
                <Draggable
                  index={index}
                  key={section.resource.payload.id}
                  draggableId={String(section.resource.payload.id)}
                >
                  {(provided) => (
                    <SectionContent section={section} store={store} provided={provided} />
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    ))
    .getOrElse(emptyFragment);
}

export default observer(Sections);
